import { render, staticRenderFns } from "./gift_card_list.vue?vue&type=template&id=56c8a1e2"
import script from "./gift_card_list.vue?vue&type=script&lang=js"
export * from "./gift_card_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports